import React, {useEffect, useState} from 'react';
import {withStyles} from "@material-ui/core/styles";
import {connect} from "react-redux";
import {listSurveys, startSurvey} from "../../../../../state/actions/surveyActions";
import SurveyGroupOption from "./SurveyGroupOption";
import LoadingCircle from "../../../../util/common/LoadingCircle";
import FolderSelector from "../../folders/FolderSelector";

const styles = {
  root:{
    display: "flex",
    flexDirection: "column",
    '& > div:first-child > div:first-child > div:first-child > div:first-child': {
      borderWidth: "0 0 1px"
    }
  },
  folder: {
    display: "flex",
    flexWrap: "wrap",
    padding: "0 0.5rem",
    gap: "0 0.5rem",
    alignItems: "center",
    borderBottom: "1px solid rgba(0,0,0,0.12)",
    '& > span': {
      padding: '0.5rem 0',
    },
    '& > div': {
      width: '15em',
    },
  },
  loading: {
    padding: "0.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // fontSize: "1rem",
    fontWeight: 500,
    gap: "0.5rem 1rem",
  },
  loader: {
    margin: 0,
  },
};


function SurveySelectMenu(props) {
  const { mindfile, surveyGroups, listSurveys, startSurvey, folderList, initialFolder, addFolder, itemChangeCallback, filterName, openDataView, classes } = props;

  const [selectedFolder, setSelectedFolder] = useState(initialFolder || folderList.length  > 0 ? folderList[0] : null);
  const loading = !surveyGroups || Object.keys(surveyGroups).length === 0;

  useEffect(() => {
    if(loading) {
      listSurveys(mindfile.id)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  useEffect(() => {
    listSurveys(mindfile.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mindfile.id]);

  if(loading){
    return <div className={classes.loading}>
      <LoadingCircle size={"sm"} className={classes.loader}/>
      <span>Loading Assessments...</span>
    </div>
  }

  return (
    <div id="surveyMenu" className={classes.root}>
      <div className={classes.folder}>
        <span>Select folder for new assessment:</span>
        <div>
          <FolderSelector
            label="Folder"
            id="assessmentFolder"
            selectedFolder={selectedFolder}
            folderList={folderList}
            addFolder={addFolder}
            handleFolderSelect={(newVal) => setSelectedFolder(newVal)}
          />
        </div>
        {/*<Button*/}
        {/*  onClick={() => {*/}
        {/*    console.log(generateSurveysHelp(surveyGroups))*/}
        {/*  }}*/}
        {/*>Help</Button>*/}
      </div>
      {Object.entries(surveyGroups).map(([id, group], i) =>
        <SurveyGroupOption
          helpIndex={"4"}
          key={id}
          isRoot
          open={true}
          rootNext={group?.info?.next?.id}
          surveyGroup={group}
          rootGroups={surveyGroups}
          startSurvey={(surveyId, callback) => startSurvey(mindfile.id, selectedFolder.id, surveyId, (data) => {
            itemChangeCallback();
            typeof(callback) !== "function" || callback(data);
            })}
            filterName={filterName}
            openDataView={openDataView}
          />
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  mindfile: state.mindfile,
  surveyGroups: state.surveyGroups.root
})

const mapDispatchToProps = {
  listSurveys,
  startSurvey,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SurveySelectMenu));
